import { render, staticRenderFns } from "./Recipiente.vue?vue&type=template&id=c6e42a70&scoped=true&"
import script from "./Recipiente.vue?vue&type=script&lang=js&"
export * from "./Recipiente.vue?vue&type=script&lang=js&"
import style0 from "./Recipiente.vue?vue&type=style&index=0&id=c6e42a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e42a70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VImg,VRow,VSelect})
